import { render } from "./ModalAddUser.vue?vue&type=template&id=411e67d1"
import script from "./ModalAddUser.vue?vue&type=script&lang=js"
export * from "./ModalAddUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__